export const publicShareCopy = (english: boolean) =>
  english
    ? {
        title: 'Files shared with me',
        download: 'Download',
        zip: 'Download zip',
        preparing: 'Preparing ZIP…',
        empty: 'This folder is empty.',
        failed: 'Unable to load this share. It may have expired or been withdrawn.',
        downloadFailed: 'Unable to download. Please retry. ZIP downloads support up to 100 files and 100 MiB.',
        retry: 'Retry',
        password: 'Share password',
        unlock: 'Unlock share',
        passwordError: 'Unable to unlock this share. Check the password and retry.',
        sessionExpired: 'Your share session has expired. Enter the password again.',
        limits: 'ZIP includes the selected folder and its subfolders, up to 100 files and 100 MiB.',
      }
    : {
        title: '與我分享的檔案',
        download: '下載',
        zip: '下載 ZIP',
        preparing: '正在準備 ZIP…',
        empty: '此資料夾沒有內容。',
        failed: '無法載入分享內容，連結可能已到期或撤銷。',
        downloadFailed: '無法下載，請重試。ZIP 最多支援 100 個檔案及 100 MiB。',
        retry: '重試',
        password: '分享密碼',
        unlock: '開啟分享',
        passwordError: '無法開啟分享，請確認密碼後重試。',
        sessionExpired: '分享驗證已到期，請重新輸入密碼。',
        limits: 'ZIP 包含所選資料夾與子資料夾，最多支援 100 個檔案及 100 MiB。',
      };
